import api from '@/api/axios'


import { cache } from '@/api/axios';
import router from '@/router';

export default {
    namespaced: true,
    state: {
        token: localStorage.getItem('token') || null,
        user: JSON.parse(localStorage.getItem('user')) || null
    },
    getters: {
        authenticated(state) {
            return state.token && state.user
        },
        user(state) {
            return state.user;
        }
    },
    mutations: {
        SET_TOKEN(state, token) { 
            state.token = token;
            localStorage.setItem('token', token);
        },
        SET_USER(state, data) {
            state.user = data;
            localStorage.setItem('user', JSON.stringify(data));
        }
    },
    actions: {
        // eslint-disable-next-line no-unused-vars
        async verifyStatusRegister({ commit, dispatch }, credentials) {
            // eslint-disable-next-line no-debugger
            let response = await api.post('/login/verifyStatusRegister', credentials);
            if(response.status == 200){
                return response;
            }else{
                return response;
            }
        },

        async signIn({ commit, dispatch }, credentials) {
            let response = await api.post('/login', credentials);
            if(response.status == 200){
                cache.clear();
                dispatch('attemptUser', response.data.data.User);
                dispatch('attempt', response.data.data.BearerToken);
            }else{
                commit('SET_TOKEN', null)
                commit('SET_USER', null);
            }
            return response;
        },

        // eslint-disable-next-line no-unused-vars
        async verifyLogin({ commit, dispatch }, credentials) {
            return await api.post('/Login/VerifyLogin', credentials);
            
        },

        async attempt({ commit, state }, token) { 
            if (token) {
                commit('SET_TOKEN', token)
            }

            if (!state.token) {
                return
            }
        },

        async logout({ commit }) {

            let response = await api.post('/Login/logoff');

            if(response){
                cache.clear();
                localStorage.removeItem('NomeRazaoSocial');
                localStorage.removeItem('Email');
                localStorage.removeItem('token');
                commit('SET_USER', null);
                commit('SET_TOKEN', null);
                router.push({ name: 'UserLogin' });
            }

        },

        async attemptUser({ commit, state }, userDate) {

            if (userDate) {
                commit('SET_USER', userDate)
            }

            if (!state.token) {
                return
            }

        }
    }
};
